module.exports = __webpack_public_path__ + "static/media/NP.21bd700b.png";